import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bucket text-center" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "img" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "text ap-green" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", { href: $props.url }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: $props.image,
          alt: $props.text
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString($props.text), 1)
    ], 8, _hoisted_2)
  ]))
}